import { render } from "./SignInLanguageSwitcher.vue?vue&type=template&id=d939578a&scoped=true"
import script from "./SignInLanguageSwitcher.vue?vue&type=script&lang=js"
export * from "./SignInLanguageSwitcher.vue?vue&type=script&lang=js"

import "./SignInLanguageSwitcher.vue?vue&type=style&index=0&id=d939578a&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d939578a"]])

export default __exports__